<script lang="ts" setup>
import type { EditorialTimelineBlockProps } from './EditorialTimelineBlock.props'

defineProps<EditorialTimelineBlockProps>()

const emit = defineEmits<{ selected: [index: number] }>()
const el = ref<HTMLElement | null>(null)
defineExpose({ el })

const handleClick = (yearIndex: number) => {
  emit('selected', yearIndex)
}
</script>

<template>
  <div ref="el" class="flex flex-col">
    <!-- DOT & LINE -->
    <div>
      <div class="mb-2 mt-2 flex items-center md:mt-4 lg:mt-6">
        <div class="bg-primitives-black h-3 w-3 rounded-full"></div>
        <div v-if="!isLastBlock" class="bg-primitives-black h-px w-full"></div>
      </div>
      <!-- TITLE -->
      <button
        class="text-light-1 text-timeline mb-6 w-min px-4 md:mb-8 lg:mb-12"
        @click="handleClick(index)"
      >
        {{ titleBlock }}
      </button>
    </div>
    <!-- CARDS -->
    <div
      class="flex cursor-grab flex-nowrap gap-2 md:gap-4 lg:gap-6"
      data-dragscroll
    >
      <EditorialTimelineCard
        v-for="(card, index) in cards"
        :key="`timeline-${titleBlock}-card-n-${index}`"
        :aspect-ratio="aspectRatio"
        :card="card"
        :class="{ 'last:pr-16 last:lg:pr-[120px]': !isLastBlock }"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.text-timeline {
  @screen md {
    font-size: 4rem;
    font-weight: 300;
    line-height: 7.5rem;
    letter-spacing: 0.025rem;
  }

  @screen lg {
    font-size: 5rem;
    font-weight: 300;
    line-height: 7.5rem;
    letter-spacing: 0.025rem;
  }
}
</style>
